import Icon from '@ant-design/icons';
import type { CustomIconComponentProps, IconComponentProps } from '@ant-design/icons/lib/components/Icon';

type IconProps = Pick<IconComponentProps, 'onClick'>;

const DotsSvg = ({ fill = '#808CB2' }: { fill?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            d="M9.99737 14.5852C9.76811 14.5852 9.58053 14.7728 9.58303 15.0021C9.58303 15.2313 9.77061 15.4189 9.99987 15.4189C10.2291 15.4189 10.4167 15.2313 10.4167 15.0021C10.4167 14.7728 10.2291 14.5852 9.99737 14.5852"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.99737 9.58316C9.76811 9.58316 9.58053 9.77074 9.58303 10C9.58303 10.2293 9.77061 10.4168 9.99987 10.4168C10.2291 10.4168 10.4167 10.2293 10.4167 10C10.4167 9.77074 10.2291 9.58316 9.99737 9.58316"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.99737 4.58107C9.76811 4.58107 9.58053 4.76865 9.58303 4.99791C9.58303 5.22717 9.77061 5.41475 9.99987 5.41475C10.2291 5.41475 10.4167 5.22717 10.4167 4.99791C10.4167 4.76865 10.2291 4.58107 9.99737 4.58107"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);

const Dots = (props: Partial<CustomIconComponentProps & IconProps>) => (
    <Icon component={() => <DotsSvg fill={props.fill || 'currentColor'} />} {...props} />
);

export default Dots;
